import React from 'react';
import './FilesToolbarButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FilesToolbarButton = ({ icon, onClick, id, title, disabled = false }) => (
  <button className="btn btn-lg btn-outline-accent2 files-toolbar-button" onClick={onClick} disabled={disabled} title={title} id={id}>
      <FontAwesomeIcon className='files-toolbar-icon' icon={icon} />
    </button>
);

export default FilesToolbarButton;